import { call } from '../@';

export default async function getInvitationUsers(transactionId: string, role: string, side: string) {
	const res = await call('invitation-getUsers', { transactionId, role, side });

	return res.users;
}
